import nameMinusExtension from "@local/extensions/utilities/name-minus-extension.js";
import extension from "@local/extensions/utilities/extension.js";

function getItemsWithOneMarker(grp) {
  const locsByRecord = grp.locations.order.reduce((acc, id) => {
    const loc = grp.locations[id];
    if (!acc[loc.record_id]) {
      acc[loc.record_id] = [];
    }

    acc[loc.record_id].push(loc);
    return acc;
  }, {});

  const itemsByOpening = grp.items.order.reduce((acc, id) => {
    const item = grp.items[id];

    if (!item.is_collection && item.collection_id) {
      if (!acc[item.collection_id]) {
        acc[item.collection_id] = [];
      }

      acc[item.collection_id].push(item);
    }

    return acc;
  }, {});

  const openings = grp.items.order.filter((id) => {
    const item = grp.items[id];
    return item.is_collection;
  });

  const openingClips = openings.map((id) => {
    const item = grp.items[id];
    const locs = locsByRecord[item.id] || [];
    const clips = locs.filter((l) => l.clip);
    return { opening: item, clips };
  });

  const openingsWithOneClip = openingClips.filter((o) => {
    return o.clips.length === 1;
  });

  const mismatches = openingsWithOneClip.filter((o) => {
    return o.clips[0].id !== o.opening.drawing?.attachment_id;
  });

  const openingsWithNoClips = openingClips.filter((o) => {
    return o.clips.length === 0;
  });

  const openingsWithMultipleClips = openingClips.filter((o) => {
    return o.clips.length > 1;
  });

  return {
    openings,
    openingsWithOneClip,
    itemsByOpening,
    mismatches,
    openingsWithNoClips,
    openingsWithMultipleClips,
  };
}

function itemsWithOneMarker(grp) {
  const {
    openings,
    openingsWithOneClip,
    mismatches,
    openingsWithNoClips,
    openingsWithMultipleClips,
  } = getItemsWithOneMarker(grp);

  let content = `
Total openings: ${openings.length}
Openings with no clipped markers: ${openingsWithNoClips.length}
Openings with exactly one clipped marker: ${openingsWithOneClip.length}
Openings with multiple clipped markers: ${openingsWithMultipleClips.length}
Openings with a single mismatched clipped marker: ${mismatches.length}
  `;

  console.log(content);

  if (openingsWithNoClips.length) {
    const unclipped = openingsWithNoClips.map((o) => {
      return { Mark: o.opening.mark };
    });
    console.log("\nOpenings with no clipped markers:");
    console.table(unclipped);
  }

  if (openingsWithMultipleClips.length) {
    const multiples = openingsWithMultipleClips.map((o) => {
      return { Mark: o.opening.mark };
    });
    console.log("\nOpenings with multiple clipped markers:");
    console.table(multiples);
  }

  if (mismatches.length) {
    const mismatched = mismatches.map((o) => {
      const clip = o.clips[0];
      const doc = grp.documents[clip.document_id];
      const page = doc.data.pages.indices[clip.page_id] + 1;
      return { Mark: o.opening.mark, ["Document Name"]: doc.name, Page: page };
    });
    console.log("\nOpenings with a single mismatched clipped marker:");
    console.table(mismatched);
  }
}

function openingsWithNoItems(grp) {
  const { openings, openingsWithOneClip, itemsByOpening } =
    getItemsWithOneMarker(grp);

  const oneClipNoItemOpenings = openingsWithOneClip.filter((o) => {
    const items = itemsByOpening[o.opening.id] || [];
    return items.length === 0;
  });

  const content = `
All openings: ${openings.length}
Openings with one clip: ${openingsWithOneClip.length}
One-clip openings with no items: ${oneClipNoItemOpenings.length}
  `;
  console.log(content);

  const table = oneClipNoItemOpenings.map((o) => {
    const clip = o.clips[0];
    const doc = grp.documents[clip.document_id];
    const page = doc.data.pages.indices[clip.page_id] + 1;

    return {
      Mark: o.opening.mark,
      ["Document Name"]: doc.name,
      Page: page,
    };
  });
  console.table(table);
}

function repairMismatchedDrawings(grp) {
  const { mismatches } = getItemsWithOneMarker(grp);

  const updates = [];

  mismatches.forEach(({ opening, clips }) => {
    const loc = clips[0];
    const doc = grp.documents[loc.document_id];
    if (!doc) return;

    const page = doc.data.pages[loc.page_id];
    const path = `${nameMinusExtension(page.name)}.${page.page}.tiff`;
    const ext = extension(page.name);

    if (ext === "pdf") {
      const drawing = {
        attachment_id: loc.id,
        id: page.name.split("/")[0],
        name: page.label || page.name,
        type: "iiif",
        clip: loc.clip,
        path,
        extension: ext,
        properties: {
          width: loc.clip.width,
          height: loc.clip.height,
        },
      };

      updates.push({
        type: "item",
        id: opening.id,
        prop: "drawing",
        value: drawing,
      });
    }
  });

  return updates;
}

export { itemsWithOneMarker, openingsWithNoItems, repairMismatchedDrawings };
